/**
 * Routing.
 *
 * Public viewer surfaces (landing, demo, live boards, profiles, pricing, rate
 * card) need no auth. The big-screen routes render without the site chrome, since
 * they are cast to a TV. /app and /sponsor are the two signed-in areas.
 */
import { Route, Routes, useLocation } from 'react-router-dom';
import { Footer, TopNav } from './components/Shell.tsx';
import { LandingPage } from './routes/Landing.tsx';
import { PricingPage } from './routes/Pricing.tsx';
import { RateCardPage } from './routes/RateCard.tsx';
import { DemoPage } from './routes/Demo.tsx';
import { BigScreenPage } from './routes/BigScreen.tsx';
import { TournamentPage } from './routes/Tournament.tsx';
import { ScoringPage } from './routes/Scoring.tsx';
import { PlayerProfilePage } from './routes/PlayerProfile.tsx';
import { SponsorPortalPage } from './routes/SponsorPortal.tsx';
import { BillingPage, LoginPage, OrganizerDashboard } from './routes/Account.tsx';

export function App() {
  const location = useLocation();
  // Big-screen mode is chrome-free by design: nothing but the board and sponsors.
  const bare = location.pathname.endsWith('/bigscreen');

  return (
    <div className="flex min-h-screen flex-col">
      {bare ? null : <TopNav />}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/rate-card" element={<RateCardPage />} />

          <Route path="/demo" element={<DemoPage />} />
          <Route path="/demo/bigscreen" element={<BigScreenPage demo />} />

          <Route path="/t/:slug" element={<TournamentPage />} />
          <Route path="/t/:slug/bigscreen" element={<BigScreenPage />} />

          <Route path="/score" element={<ScoringPage />} />
          <Route path="/score/:tournamentId" element={<ScoringPage />} />

          <Route path="/p/:playerId" element={<PlayerProfilePage />} />

          <Route path="/login" element={<LoginPage />} />
          <Route path="/app" element={<OrganizerDashboard />} />
          <Route path="/app/billing" element={<BillingPage />} />
          <Route path="/sponsor" element={<SponsorPortalPage />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      {bare ? null : <Footer />}
    </div>
  );
}

function NotFound() {
  return (
    <div className="mx-auto max-w-[620px] px-4 py-24 text-center">
      <p className="board-title text-[72px] font-bold leading-none text-[var(--color-fairway-500)]">Lost ball</p>
      <p className="mt-3 text-sm text-[var(--color-muted)]">
        That page is out of bounds. Take a drop and head back to the{' '}
        <a href="/demo" className="text-[var(--color-fairway-300)] underline">
          live demo
        </a>
        .
      </p>
    </div>
  );
}
